import { IEditItem, EditItem } from "../common/editItem";

export interface IEmployeeGroupEditItem extends IEditItem {
    employmentId: string;
    salaryPeriodTypeId: string;
    name: string;
    description: string;
    workQueueInUse: boolean;
    locationDataInUse: boolean;
    canCreateWorkOrderInMobile: boolean;
    showFleetInMobile: boolean;
    collectiveAgreementId: string;
    workTimeAutoStartEnabled: boolean;
    workTimeAutoStartWorkTimeTypeId: string;
    workTimeAutoEndEnabled: boolean;
    workTimeAutoDrivingEnabled: boolean;
    workTimeAutoStopEnabled: boolean;
    workTimeAutoStopWorkTimeTypeId: string;
    workTimeAutoDrivingThreshold: number;
    workTimeAutoStopThreshold: number;
    paymentGroup: string;
    canEditWorkEntries: boolean;
    canAddAndEditDayBookings: boolean;
    showWorkShiftEndTimesInMobile: boolean;
    workTimeDefaultTimezoneEnabled: boolean;
    workTimeDefaultTimezone: string;
    isCommentRequiredWhenEditingWorkTime: boolean;
    dailyAllowanceSelectionOnShiftEndEnabled: boolean;
}

export class EmployeeGroupEditItem extends EditItem implements IEmployeeGroupEditItem {
    employmentId: string;
    salaryPeriodTypeId: string;
    name: string;
    description: string;
    workQueueInUse: boolean;
    locationDataInUse: boolean;
    canCreateWorkOrderInMobile: boolean;
    showFleetInMobile: boolean;
    collectiveAgreementId: string;
    workTimeAutoStartEnabled: boolean;
    workTimeAutoStartWorkTimeTypeId: string;
    workTimeAutoEndEnabled: boolean;
    workTimeAutoDrivingEnabled: boolean;
    workTimeAutoStopEnabled: boolean;
    workTimeAutoStopWorkTimeTypeId: string;
    workTimeAutoDrivingThreshold: number;
    workTimeAutoStopThreshold: number;
    paymentGroup: string;
    canEditWorkEntries: boolean;
    canAddAndEditDayBookings: boolean;
    showWorkShiftEndTimesInMobile: boolean;
    workTimeDefaultTimezoneEnabled: boolean;
    workTimeDefaultTimezone: string;
    isCommentRequiredWhenEditingWorkTime: boolean;
    dailyAllowanceSelectionOnShiftEndEnabled: boolean;

    constructor();
    constructor(obj: IEmployeeGroupEditItem);
    constructor(obj?: any) {
        super(obj);
        this.employmentId = obj && obj.employmentId || "";
        this.salaryPeriodTypeId = obj && obj.salaryPeriodTypeId || "";
        this.name = obj && obj.name || "";
        this.description = obj && obj.description || "";
        this.workQueueInUse = obj && obj.workQueueInUse || false;
        this.locationDataInUse = obj && obj.locationDataInUse || false;
        this.canCreateWorkOrderInMobile = obj && obj.canCreateWorkOrderInMobile || false;
        this.showFleetInMobile = obj && obj.showFleetInMobile !== undefined ? obj.showFleetInMobile : true;
        this.collectiveAgreementId = obj && obj.collectiveAgreementId || "";
        this.workTimeAutoStartEnabled = obj && obj.workTimeAutoStartEnabled || false;
        this.workTimeAutoStartWorkTimeTypeId = obj && obj.workTimeAutoStartWorkTimeTypeId || "";
        this.workTimeAutoEndEnabled = obj && obj.workTimeAutoEndEnabled || false;
        this.workTimeAutoDrivingEnabled = obj && obj.workTimeAutoDrivingEnabled || false;
        this.workTimeAutoStopEnabled = obj && obj.workTimeAutoStopEnabled || false;
        this.workTimeAutoStopWorkTimeTypeId = obj && obj.workTimeAutoStopWorkTimeTypeId || "";
        this.workTimeAutoDrivingThreshold = (obj && obj.workTimeAutoDrivingThreshold) ?? 30;
        this.workTimeAutoStopThreshold = (obj && obj.workTimeAutoStopThreshold) ?? 5;
        this.paymentGroup = obj && obj.paymentGroup || "";
        this.canEditWorkEntries = obj && obj.canEditWorkEntries || false;
        this.canAddAndEditDayBookings = obj && obj.canAddAndEditDayBookings || false;
        this.showWorkShiftEndTimesInMobile = obj && obj.showWorkShiftEndTimesInMobile !== undefined ? obj.showWorkShiftEndTimesInMobile : true;
        this.workTimeDefaultTimezoneEnabled = obj && obj.workTimeDefaultTimezoneEnabled || false;
        this.workTimeDefaultTimezone = obj && obj.workTimeDefaultTimezone || "";
        this.isCommentRequiredWhenEditingWorkTime = obj && obj.isCommentRequiredWhenEditingWorkTime || false;
        this.dailyAllowanceSelectionOnShiftEndEnabled = obj && obj.dailyAllowanceSelectionOnShiftEndEnabled || false;
    }
}
